module.exports = __webpack_public_path__ + "media/ballroom.990d1e0b.jpg";